import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllHomeTutorPricing = () => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [allHomeTutorPackage, setAllHomeTutorPackage] = useState([]);
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/package`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response);
        const data = response?.data;
        setAllHomeTutorPackage(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleAddNewPrice = () => {
    navigate("/add-home-tutor-pricing");
  };
  const handleViewAllPrice = () => {
    navigate("/all-home-tutor-pricing");
  };

  const handleEdit = (id) => {
    navigate(`/edit-home-tutor-pricing/${id}`);
  };
  const handleDelete = (id) => {
    const confirm = window.confirm("Are you sure you want to delete ?");
    if (confirm) {
      axios
        .delete(`${API_BASE_URL}/admin/package/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          console.log(response);
          setAllHomeTutorPackage((prev) =>
            prev.filter((item) => item._id !== id)
          );
          alert("Package deleted successfully");
        })
        .catch((error) => {
          console.log(error);
          alert("Failed to delete package");
        });
    }
  };
  return (
    <div id="chapter-inner-wrapper">
      <div className="chapter-header-div">
        <h5>All Home Tutor Package</h5>
        <div className="chapter-header-btns">
          <button className="add-chapter-btn" onClick={handleAddNewPrice}>
            + Add Price
          </button>
          <button className="all-chapters-btn" onClick={handleViewAllPrice}>
            All Price
          </button>
        </div>
      </div>

      <div className="chapter-table-container">
        <h5>All Package</h5>
        <table className="chapter-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Package Name</th>
              <th>Description</th>
              <th>Mrp</th>
              <th>Sell Price</th>
              <th>Number Of Leads</th>
              <th>Validity (in month)</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {/* Sample data rows */}
            {allHomeTutorPackage &&
              allHomeTutorPackage.map((item, idx) => (
                <tr>
                  <td>{idx + 1}</td>
                  <td>{item?.packageName}</td>
                  <td>{item?.description}</td>
                  <td>{item?.mrp}</td>
                  <td>{item?.sellPrice}</td>
                  <td>{item?.numberOfLeads}</td>
                  <td>{item?.validity}</td>

                  <td className="table-action-icons d-flex gap-1">
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(item?._id)}
                    ></i>
                    <i
                      className="fa-solid fa-trash-can"
                      onClick={() => handleDelete(item._id)}
                    ></i>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllHomeTutorPricing;
